import {
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';

import { catchError, tap } from 'rxjs/operators';

import { Observable } from 'rxjs';

import { InternetbankAppApplicationException } from '../../../common/exceptions/exceptions';
import { OperationConfirmation } from '../../../shared/confirmation/core/models/operation-confirmation.model';
import { FieldOptions } from '../../../ui/controls/field.model';
import { TooltipPopupComponent } from '../../../ui/controls/tooltip-popup/tooltip-popup.component';
import { CustomFormControl } from '../../../ui/custom-reactive-forms/custom-form-control';
import { StatementItemDTO } from '../statements-model';
import { StatementsService } from '../statements.service';

import { MessageComponent } from './../../../ui/controls/message/message.component';
import StatementOrder from './statement-order';

 
@Component({
    selector: 'app-statement-order',
    templateUrl: './statement-order.component.html',
    styleUrls: ['./statement-order.component.less'],
    standalone: false,
})
export class StatementOrderComponent implements OnInit {
	@Input()
	public content: string;

	@Input()
	public item: StatementItemDTO;

	@ViewChild(TooltipPopupComponent)
	private tooltip: TooltipPopupComponent;

	@ViewChild('rejectStatementResult')
	private messageComponent: MessageComponent;

	public checkboxStatementControl: CustomFormControl;
	public submitButtonControl: CustomFormControl;


	constructor(public statementsService: StatementsService) { }

	public ngOnInit(): void {
		this.checkboxStatementControl = StatementOrder.getClaimAgreementCheckbox(this.item.caption, this.item.id, false);

		this.submitButtonControl = new CustomFormControl(
			new FieldOptions({
				'@type': 'action-button-field',
				name: 'submitStatement',
				label: 'Подтвердить',
				css: {
					classList: [''],
					styleList: [],
				},
				required: false,
				disabled: true,
				value: true,
				hasChanged$: (control: CustomFormControl) => [
					this.checkboxStatementControl.valueChanges.pipe(
						tap((value: boolean) => {
							if (value) {
								control.enable();
							} else {
								control.disable();
							}
						}),
					),
				],
				onCancel: () => {
					this.checkboxStatementControl.enable();
					this.submitButtonControl.enable();
					this.tooltip.disabled = false;
				},
				onSave: (): Observable<void> => {
					this.checkboxStatementControl.disable();
					this.submitButtonControl.disable();
					this.tooltip.disabled = true;

					return this.statementsService.signStatementCreate(this.item);
				},
				onConfirm: (operationConfirmation: OperationConfirmation | null): Observable<void> =>
					this.statementsService.signStatementConfirm(operationConfirmation)
						.pipe(
							tap(() => {
								this.statementsService.statementSigned$.next(
									this.item.id,
								);
							}),
						),
			}),
		);
	}

	public closePopup() {
		this.tooltip.close();
	}

	public onOpenPopup() {
		this.messageComponent.close();
	}

	public rejectStatement() {
		this.messageComponent.start();
		this.statementsService.rejectStatement(this.item.regNumber)
			.pipe(
				catchError((error: InternetbankAppApplicationException) => {
					this.messageComponent.fail(error);
					throw error;
				}),
			)
			// eslint-disable-next-line @typescript-eslint/typedef
			.subscribe((x) => {
				this.messageComponent.success(x);
				this.statementsService.statementRejected$.next(this.item);
			});
	}

}
